export default {"src":"/_next/static/media/AI.f2068eb4.svg","height":18,"width":18};